export default __webpack_public_path__ + "static/media/gradient-desktop.cfbcd771.png";